// extracted by mini-css-extract-plugin
export default {"main":"Doctors_main__aBoUu","doctorsList":"Doctors_doctorsList__3l1D0","doctorFilter":"Doctors_doctorFilter__5hrKP"};